import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { fill: true },
  },
});

type TagCloseIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function TagCloseIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: TagCloseIconProps) {
  return (
    <Svg
      width={10}
      height={20}
      viewBox="0 0 10 20"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M5 8.89L8.89 5 10 6.11 6.11 10 10 13.89 8.89 15 5 11.11 1.11 15 0 13.89 3.89 10 0 6.11 1.11 5 5 8.89z"
        fill="#1A202C"
        className={pathClassName}
      />
    </Svg>
  );
}

export default TagCloseIcon;
